import translationFr from './fr';

const translationSodexo = {
    ...translationFr,
    'legend.WEB': "Click'n'Collect",
    'analyticsPage.needBrandSelection': 'Comme vous êtes admin, vous devez selectionner au minimum un site.',
    'analyticsPage.notAuthorizedToSeeBrand': "Vous n'êtes pas authorisé à voir ce site.",
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'Vous ne pouvez pas sélection à la fois des sites de restauration collective et commerciale.',
    'analytics.filter.web': "Click'n'Collect",
    'leaderboard.title': 'Classement des points de vente',
    'leaderboard.restaurantName': 'Points de vente',
    'leaderboard.ordersCount': 'Tickets',
    'leaderboard.RestaurantSearchPlaceholder': 'Rechercher un point de vente',
    'iopay.configuration.title': 'Paramètres IO Pay',
    'edenred.form.name': 'Nom du point de vente',
    'edenred.form.placeholder.name': 'Le nom de mon point de vente',
    'ubereats.description.secondpart': 'Comment trouver le Store ID de mon restaurant ?',
    'deliverect.subtitle': 'Comment configurer mon intégration avec Deliverect ?',
    'deliveroo.subtitle': 'Comment configurer mon intégration avec Deliveroo ?',
    'status.status': 'Status',
    'external_pos.subtitle': 'Comment configurer mon POS externe Deliverect ?',
    'webhook.secondpart.subtitle': 'Comment configurer le webhook ?',
    'webhook.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'sidebar.orders': 'Tickets',
    'sidebar.customers': 'Consommateurs',
    'sidebar.brand': 'Site',
    'sidebar.brands': 'Sites',
    'sidebar.restaurants': 'Points de vente',
    'sidebar.exportsEwallets': 'Badge',
    'sidebar.salesSummary': 'Synthèse financière - SRC',
    'sidebar.ioPay': 'IO Pay',
    'sidebar.analytics': 'Tableau de bord',
    'imageInput.section.modal.resize.details':
        "Utilisez cette option lorsque vous envoyez des images qui seront utilisées comme arrière-plan pour des bornes ou le Click'n'Collect.",
    'integrations.stripeDescription':
        "Intégrez Stripe à votre site et permettez à vos clients de connecter facilement leur compte pour une expérience du Click'n'Collect optimale.",
    'pricingRule.emptyMessage': 'Aucun régime tarifaire affilié à ce site.',
    'pricingRule.tableCard.subtitle':
        "Les régimes tarifaires sont des ensembles d'une ou plusieurs subvention(s) en usage dans vos établissements",
    'pricingRule.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'pricingRule.form.isUrssafEnabled':
        'Appliquer le minimum URSSAF à ce régime tarifaire ? (Uniquement pour les commandes CAT et API Panier)',
    'pricingRule.form.compositionDescription':
        'Les régimes tarifaires sont des ensembles d’une ou plusieurs admission(s), subvention(s) et composants hors CA.',
    'pricingRule.tableCard.description': `Si le régime tarifaire contient une subvention en % et une subvention en €, placez la subvention qui doit être déduite sur l'ensemble du montant de la commande en première position. Les subventions suivantes porteront sur le montant restant à payer, après déduction des subventions placées avant.`,
    'pricingRule.channels.web': "Click'n'Collect",
    'entranceFee.descCustomUse': 'Activation et personnalisation par point de vente de l’admission',
    'entranceFee.emptyMessage': "Aucun frais d'admission affilié à ce site.",
    'entranceFee.tableCard.subtitle':
        'Créez et gérez les différents frais d’admissions utilisés dans vos points de vente',
    'entranceFee.restaurants': 'Points de vente',
    'entranceFee.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'grant.desc1':
        'La subvention de 15,00 € ne s’applique que si :\n        Aujourd’hui, le client n’a pas déjà été soumis 3.65 fois à cette subvention\n        ET si le montant de sa part alimentaire dépasse 15,00 €.',
    'grant.desc2':
        'La subvention de 15,00 € ne s’applique que si :\n    Aujourd’hui, le client n’a pas déjà été soumis 3.65 fois à cette subvention\n    ET si le montant de sa part alimentaire dépasse 15,00 €.\n    ET si son panier contient au moins 1 produit indiqué comme subventionnable.',
    'grant.restaurants': 'Points de vente',
    'grant.emptyMessage': 'Aucune subvention affiliée à ce site.',
    'grant.tableCard.subtitle': 'Créez et gérez les différentes subventions utilisées dans vos points de vente',
    'grant.table.restaurant': 'Point de vente',
    'grant.table.dailyLimit': 'Utilisation max.',
    'grant.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ?',
    'group.emptyMessage': 'Aucune société affiliée à ce site.',
    'group.modal.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cette société ?',
    'options.shuffleRestaurants': "Rendre aléatoire l'ordre d'affichage des points de vente",
    'restaurant.search': 'Rechercher un point de vente',
    'restaurant.name': 'Nom du point de vente',
    'auto.billing.request.popup.confirm.text': 'Pouvez-vous confirmer cette action ?',
    'auto.billing.request.preview.errorUndefinedReferential': "Aucun référentiel n'est defini pour le site",
    'auto.billing.request.filter.restaurants.title': 'CHOIX DES POINTS DE VENTE',
    'auto.billing.request.filter.restaurants.all': 'Tous les points de ventes',
    'auto.billing.referential.billingEntities.table.emptyMessage':
        "Aucune entitité de facturation n'est définie pour ce site",
    'route.brands': 'Sites',
    'route.brandMedias': "Banque d'images",
    'route.configIOPay': 'Configuration IO Pay',
    'route.brandRestaurants': 'Points de vente',
    'brandRestaurants.newRestaurant': '+ Nouveau point de vente',
    'brandRestaurants.create.restaurantInfo': 'Informations du point de vente',
    'brandRestaurants.create.restaurantName': 'Nom du point de vente',
    'brandRestaurants.create.operationZone': "Zone d'opération",
    'brandRestaurants.create.operationZone.noSelectionMessage':
        "Veuillez sélectionner une zone d'opération pour continuer.",
    'brandRestaurants.create.operationZone.skip': 'Passer - configurer plus tard',
    'brandRestaurants.create.operationZoneConfigure': "Configuration de la zone d'opération",
    'brandRestaurants.create.operationZone.selectProvider': 'Sélectionnez le mode de conformité',
    'route.createGrant': 'Nouvelle Subventions',
    'route.orders': 'Tickets',
    'route.restaurantMedias': "Banque d'images",
    'route.brandCustomer': 'Consommateurs',
    'route.brandOrders': 'Tickets',
    'route.salesSummary': 'Synthèse Financière - SRC',
    'brand.adminTools.addUserToRestaurant.title':
        'Assigner un compte point de vente à un autre point de vente du même site',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId du point de vente à assigner',
    'brand.adminTools.deleteUnassignedImages.title': 'Supprimer les images non utilisées de ce site',
    'brand.adminTools.deleteUnassignedImages.description2':
        "Il est conseillé de supprimer tous les menus inutiles du site et de ses points de vente avant d'executer ce script, afin que le nettoyage soit efficace.",
    'brand.adminTools.copySchedules.title':
        "Copie des horaires de collecte ou CEL d'un point de vente vers un/des autre(s)",
    'spotlight.search.placeholder': 'Que voulez-vous faire ?',
    'spotlight.context.brand': 'Site',
    'spotlight.context.restaurant': 'Point de vente',
    'orderList.title': 'Tickets',
    'orderList.subtitle': 'Retrouver les Tickets de vos clients et vos amis proches',
    'orderList.filters.allRestaurants': 'Tous les points de vente',
    'orderList.filters.restaurantHeader': 'Mes points de vente',
    'orderList.filters.restaurantPlaceholder': 'Rechercher un point de vente',
    'order.field.restaurant': 'Point de vente',
    'order.paymentMethod.EWallet': 'Badge',
    'orderDetail.title.2': "Click'n'Collect",
    'orderDetail.Pos.restaurant': 'Point de vente',
    'ioPay.title': 'IO Pay',
    'transaction.field.brand': 'Site',
    'transaction.field.restaurant': 'Point de vente',
    'transaction.source.WEBORDERING': "Click'n'Collect",
    'configuration.iopay.title': 'Configuration IO Pay',
    'configuration.iopay.subtitle':
        'Ici, vous retrouverez toutes les entités légales que vous avez créées pour votre entreprise. Nous avons rassemblé pour vous une vue d’ensemble claire et concise de vos points de vente et e-wallet afin de faciliter leurs configurations.',
    'legalEntity.field.associatedRestaurants': 'Points de vente associés',
    'legalEntity.action.addRestaurant': 'Ajouter un point de vente',
    'legalEntity.wizard.step2.title': "Ajout d'un nouveau point de vente",
    'legalEntity.wizard.step2.titleMassCatering': "Ajout d'un nouveau point de vente ou e-wallet",
    'legalEntity.wizard.step2.chooseRestaurant': 'Sélectionner un point de vente',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Sélectionner un point de vente ou e-wallet',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Renseigner les identifiants CONECS (ID) pour pouvoir activer le moyen de paiement CONECS sur ce point de vente pour les paiements en proximité',
    'legalEntity.wizard.step2.selectRestaurant': 'Point de vente',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Point de vente ou e-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Veuillez sélectionner un point de vente',
    'legalEntity.wizard.step2.phoneNumber.placeholder':
        'Veuillez saisir le numéro de téléphone à associer à ce point de vente',
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Adresse du point de vente',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': "Veuillez saisir l'adresse du point de vente",
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'Code postal du point de vente',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': 'Veuillez saisir le code postal du point de vente',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Veuillez saisir la ville du point de vente',
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'Renseigner les identifiants CONECS (ID) pour pouvoir activer le moyen de paiement CONECS sur ce point de vente pour les paiements en proximité',
    'reports.title': 'Rapports IO Pay',
    'reports.subtitle':
        'Consultez les transactions virées sur votre compte bancaire, avec le détail par transaction pour chaque virement. Ce rapport vous permet d’assurer une fiabilisation comptable des transactions E-wallet avec IO Pay.',
    'reports.error.missingBrand': "Pas de site liée à l'utilisateur actuel",
    'paymentMethods.tab.web': "Click'n'Collect",
    'paymentMethods.tab.kiosk.integration.desc1':
        'Le paiement par CB sur les bornes nécessite que le point de vente possède un compte Ingenico.',
    'paymentMethods.tab.kiosk.payment.desc':
        'Indiquez aux utilisateurs les moyens de paiement acceptés par le point de vente au comptoir.',
    'paymentMethods.consumptionMode': 'Sélectionner les moyens de consommation',
    'configure.iopay': 'Configurer IO Pay',
    'configure.ewallet': 'Configurer Badge',
    'configure.stripe.iopayConfigured': 'Impossible de configurer Stripe, IO Pay étant utilisé.',
    'configure.iopay.stripeConfigured': 'Impossible de configurer IO Pay, Stripe étant utilisé.',
    'customer.tab.ewallet': 'Badge',
    'customer.student.info.account.type': 'Type de compte client',
    'customer.student.info.group': 'Société',
    'customer.student.overdraft.title': 'Découvert Badge autorisé',
    'customer.student.badge.title': 'Blocage du badge convive',
    'customer.student.badge.description': 'Vous pouvez temporairement bloquer le fonctionnement du badge.',
    'pricingRevaluation.table.emptyMessage': 'Aucun menus trouvé pour ce point de vente',
    'pos_layout.publishDescription':
        'Êtes-vous sûr de vouloir sauvegarder et publier le menu et le plan de touche sur le(s) POS associé(s) ?',
    'customers.page.title': 'Consommateurs',
    'customers.page.description': 'Consultez vos consommateurs',
    'customers.orderCount': 'Nombre de Tickets',
    'customers.ewalletBalance': 'Solde Badge',
    'customers.showArchivedCustomers': 'Afficher les consommateurs archivés',
    'customers.showDisabledCustomers': 'Afficher les consommateurs désactivés',
    'menu.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer le menu : "{menuName}" ?',
    'menu.importPOS.step1.title': 'Nouveau: Ajouter les menus de vos caisses ici en un clic !',
    'menu.importPOS.step1.bullet.3':
        "La possibilité d'utiliser le même menu pour la caisse, la borne et le Click'n'Collect",
    'menu.importPOS.step3.title': "C'est tout bon !",
    'menu.importPOS.step3.subtitle': 'Vous pouvez désormais gérer vos caisses directement depuis le back-office !',
    'menuoperation.page.description': 'Retrouvez les opérations sur les menus pour votre point de vente',
    'menu.tags.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} tag(s) ?',
    'menu.steps.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} étape(s) ?',
    'menu.categories.deleteCategory.confirm':
        'Êtes-vous sûr de vouloir supprimer cette catégorie ?\nElle ne sera plus disponible et ses enfants (produits et sous catégories) deviendront orphelins.',
    'menu.products.copy.form.channel.web': "Click'n'Collect ou à table",
    'menu.products.copy.form.disclaimer':
        "Attention ce(s) produit(s) seront copiés sur tous les points de vente sélectionnés, dans tous leurs menus. Avant d'enregistrer, vérifiez leur nom, description, image, TVA, prix.",
    'menu.products.delete.confirm': 'Êtes-vous sûr de vouloir supprimer {count} produit(s) ?',
    'menu.products.form.ticketLabel': 'Libellé ticket de caisse',
    'menu.products.form.sku.noOption': "Un nouvel SKU ne peut être créé qu'au niveau du site",
    'reportGenerationsHistory.tableRow.reportType.orders': 'Tickets',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary': 'Synthèse financière - SRC',
    'report.filtersModal.form.restaurantLabel': 'Points de vente',
    'report.filtersModal.form.loyaltyLabel': 'Afficher uniquement les Tickets payées avec la fidelité',
    'report.savedFiltersDropdown.deleteModal.description': 'Êtes-vous sûr de vouloir supprimer ?',
    'salesSummary.form.restaurants': 'Points de vente',
    'brandHistory.restaurant': 'Point de vente',
    'crossSelling.modal.delete.description': 'Êtes-vous sûr de vouloir supprimer la page : "{crossSellingName}" ?',
    'crossSelling.products.restaurantName': 'Point de vente',
    'order.field.pricingRuleInOrder': 'Régime tarifaire appliqué',
    'order.field.customerNameMassCatering': 'Nom & prénom consommateur',
    'group.tableCard.title': 'Sociétés',
    'group.tableCard.action': '+ Créer une nouvelle société',
    'group.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par société et associez y les différents régimes tarifaires.',
    'group.tableCard.subtitle2': "Définissez ici les différentes possibilités d'organisation de vos convives.",
    'group.name': 'Société',
    'group.warning.group_name_already_exist.message': 'Le nom de la société existe déjà.',
    'group.warning.group_name_already_exist.description':
        'Veuillez proposer un nouveau nom de société ou associer le(s) régime(s) tarifaire(s) sélectionné(s) à la société déjà existante.',
    'group.modal.deleteError': 'Vous ne pouvez pas supprimer cette société.',
    'group.modal.deleteErrorReason':
        'Veuillez désaffecter le(s) convive(s) associé(s) afin de finaliser cette suppression.',
    'group.modal.conflict.error.message': 'Vous ne pouvez pas modifier cette société',
    'group.modal.conflict.error.description': 'Veuillez réaffecter le(s) convive(s) avant de modifier cette société',
    'group.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer cette société',
    'group.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer cette société',
    'group.modal.import.title': 'Importer des Sociétés, Départements, Services et Régimes Tarifaires',
    'group.modal.import.secondPart':
        'Remplir le fichier modèle avec les informations de vos sociétés, départements, services et régimes tarifaires à ajouter ou modifier',
    'group.modal.import.warning':
        "La suppression d'une société, département, service et régime tarifaire se fait uniquement depuis le backoffice Innovorder",
    'group.export.group': 'Société',
    'group.export.section': 'Département',
    'group.export.subsection': 'Service',
    'group.modal.import.report.groups': 'Sociétés',
    'group.modal.import.report.sections': 'Départements',
    'group.modal.import.report.subsections': 'Services',
    'groups.export.student.group': 'Société',
    'groups.export.student.section': 'Département',
    'groups.export.student.subSection': 'Service',
    'section.tableCard.title': 'Départements',
    'section.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par département et associez y les différents régimes tarifaires.',
    'section.tableCard.action': '+ Créer un nouveau département',
    'section.name': 'Département',
    'group.warning.section_name_already_exist.message': 'Le nom du département existe déjà.',
    'group.warning.section_name_already_exist.description':
        'Veuillez proposer un nouveau nom de département ou associer le(s) régime(s) tarifaire(s) sélectionné(s) au département déjà existant.',
    'section.modal.conflict.error.message': 'Vous ne pouvez pas modifier ce département',
    'section.modal.conflict.error.description': 'Veuillez réaffecter le(s) convive(s) avant de modifier ce département',
    'section.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer ce département',
    'section.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer ce département',
    'subsection.tableCard.title': 'Services',
    'subsection.tableCard.subtitle':
        'Définissez les possibilités de regroupement de vos convives par service et associez y les différents régimes tarifaires.',
    'subsection.tableCard.action': '+ Créer un nouveau service',
    'subsection.name': 'Service',
    'group.warning.sub_section_name_already_exist.message': 'Le nom du service existe déjà.',
    'group.warning.sub_section_name_already_exist.description':
        'Veuillez proposer un nouveau nom de service ou associer le(s) régime(s) tarifaire(s) sélectionné(s) au service déjà existant.',
    'subsection.modal.conflict.error.message': 'Vous ne pouvez pas modifier ce service',
    'subsection.modal.conflict.error.description': 'Veuillez réaffecter le(s) convive(s) avant de modifier ce service',
    'subsection.delete.modal.conflict.error.message': 'Vous ne pouvez pas supprimer ce service',
    'subsection.delete.modal.conflict.error.description':
        'Veuillez réaffecter le(s) convive(s) avant de supprimer ce service',
    'group.table.name': 'Société',
    'section.table.name': 'Département',
    'subsection.table.name': 'Service',
    'student.table.group': 'Société',
    'student.table.section': 'Département',
    'student.table.subsection': 'Service',
    'student.form.group': 'Société',
    'student.form.section': 'Département',
    'student.form.subsection': 'Service',
    'customer.student.info.section': 'Département',
    'customer.student.info.sub.section': 'Service',
    'guestHierarchyInfo.content':
        "Lors de la création d'un convive, les régimes tarifaires proposés sont automatiquement filtrés en fonction de la société, du département ou du service sélectionné.",

    // Guest hierarchy Training
    'guestHierarchyTraining.page1.title': 'Bienvenue sur l’encadrement des parcours clients',
    'guestHierarchyTraining.page1.content':
        "L’encadrement des parcours clients permet un paramétrage strict des comptes convives dans le Back-Office (BO). Il repose sur une hiérarchie en <b>Société → Département → Service</b> et l'assignation de <b>régimes tarifaires</b> à ces éléments. Cette structuration garantit une gestion optimisée et cohérente.",
    'guestHierarchyTraining.page2.title': 'Accéder à la Hiérarchisation',
    'guestHierarchyTraining.page2.content':
        'Ouvrez le nouvel onglet <b>Hiérarchisation</b>. Cet espace permet de <b>créer, modifier</b> les sociétés, départements et services.',
    'guestHierarchyTraining.page3.title': 'Créer ou modifier une Société',
    'guestHierarchyTraining.page3.content':
        '• Accédez à <b>Hiérarchisation > Sociétés.</b> {br}• Cliquez sur <b>"Créer une société"</b> ou modifiez une existante. {br}• Un libellé unique est requis. (1) {br}• Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à cette société (2)',
    'guestHierarchyTraining.page4.title': 'Créer ou modifier un Département',
    'guestHierarchyTraining.page4.content':
        '• Accédez à <b>Hiérarchisation > Départements.</b> {br}• Cliquez sur <b>"Créer un département"</b> ou modifiez une existante. {br}• Assignez un département à une <b>société existante</b>. (1) {br}• Un libellé unique est requis. (2) {br} • Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à ce département (3)',
    'guestHierarchyTraining.page5.title': 'Créer ou modifier un Service',
    'guestHierarchyTraining.page5.content':
        '• Accédez à <b>Hiérarchisation > Services.</b> {br}• Cliquez sur <b>"Créer un service"</b> ou modifiez une existante. {br}• Assignez un service à un <b>département existant</b>. (1 et 2) {br}• Un libellé unique est requis. (3) {br} • Définissez les <b>régimes tarifaires autorisés</b> pour les convives rattachés à ce service (4)',
};

export type TranslationKey = keyof typeof translationSodexo;
export default translationSodexo;
